/** Shared raising-mode normalizer (avoids circular imports between properties and submissions). */
export const normalizeRaisingMode = (mode) =>
  mode === "min_investment" ? "min_investment" : "co_owners";
